import React from 'react'
import $ from 'jquery'
window.jQuery = $
require('jquery-ui-dist/jquery-ui')

const defaultClasses = {
  "ui-slider": "ui-corner-all",
  "ui-slider-handle": "ui-corner-all slider-custom",
}

const Slider = ({
  animate = false,
  classes = defaultClasses,
  disabled = false,
  max = 300,
  min = 0,
  orientation = 'horizontal',
  step = 1,
  defaultValue = [''],
  handleIdPrefix = null,
  onSliderChanged = () => {},
  filterResetSubscription = () => {},
}) => {
  const [sliderVal, setSliderVal] = React.useState([''])
  const rangeEl = React.useRef(null)

  const getSlider = () => {
    if (rangeEl) {
      return $(rangeEl.current)
    }
  }

  const changeSliderOption = (optionName, value) => {
    const $slider = getSlider()
    if ($slider) {
      $slider.slider('option', optionName, value)
    }
  }

  const setSliderValue = (value) => {
    const $slider = getSlider()
    if ($slider) {
      $slider.slider('value', value)
    }
  }

  // initial configuration and teardown
  React.useEffect(() => {
    const $slider = getSlider()
    if ($slider) {
      $slider.slider({
        animate,
        // classes,
        disabled,
        max,
        min,
        orientation,
        range : false,
        step,
        value: defaultValue,
        // slide is fired while sliders are moving
        // set the componenet slider state imperatively
        slide: function(event, ui) {
          setSliderVal(ui.value == defaultValue ? '' : ui.value)
        },
        // change is fired when sliders stop moving
        // call parent change function when sliders settle
        change: function (event, ui) {
          onSliderChanged(ui.value)
        }
      })
      // update component state with the initial values
      setSliderVal('')
    }
    return () => {
      const $slider = getSlider()
      if ($slider) {
        $slider.slider('destroy')
      }
    }
  }, [])

  React.useEffect(() => {
    function resetFilter() {
      setSliderValue(defaultValue)
      setSliderVal(defaultValue)
      onSliderChanged('')
    }
    filterResetSubscription(resetFilter)
    return () => {
      filterResetSubscription(null)
    }
  }, [])

  // slider option hooks
  React.useEffect(() => changeSliderOption('animate', animate), [ animate, ])
  React.useEffect(() => changeSliderOption('classes', classes), [ classes, ])
  React.useEffect(() => changeSliderOption('disabled', disabled), [ disabled, ])
  React.useEffect(() => changeSliderOption('max', max), [ max, ])
  React.useEffect(() => changeSliderOption('min', min), [ min, ])
  React.useEffect(() => changeSliderOption('orientation', orientation), [ orientation, ])
  React.useEffect(() => changeSliderOption('step', step), [ step, ])


  return <>
    <div id={'slider'} ref={rangeEl}>
      {/* 
          only include handles if there's a custom id specified.
          otherwise styling them is not going to work.
       */}
      { handleIdPrefix && <span id={`${handleIdPrefix}`} className={'ui-slider-handle slider-custom'}>{sliderVal}</span> }
    </div>
  </>
}

export default Slider